import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_TRIALGROUPLABORATORYPERSONNEL_LOAD,
    ACTION_TRIALGROUPLABORATORYPERSONNEL_LOAD_BY_ID,
    ACTION_TRIALGROUPLABORATORYPERSONNEL_LOAD_BY_LABORATORY_ID,

    ACTION_TRIALGROUPLABORATORYPERSONNEL_SAVE,

    ACTION_TRIALGROUPLABORATORYPERSONNEL_CREATE,

    ACTION_TRIALGROUPLABORATORYPERSONNEL_VALIDATE,

    ITrialGroupLaboratoryPersonnelsLoadAction,
    ITrialGroupLaboratoryPersonnelLoadByIdAction,
    ITrialGroupLaboratoryPersonnelLoadByLaboratoryIdAction,
    ITrialGroupLaboratoryPersonnelLoadFailureAction,
    ITrialGroupLaboratoryPersonnelLoadSuccessAction,

    ITrialGroupLaboratoryPersonnelSaveAction,
    ITrialGroupLaboratoryPersonnelSaveSuccessAction,
    ITrialGroupLaboratoryPersonnelSaveFailureAction,

    ITrialGroupLaboratoryPersonnelCreateAction,
    ITrialGroupLaboratoryPersonnelCreateSuccessAction,
    ITrialGroupLaboratoryPersonnelCreateFailureAction,

    ITrialGroupLaboratoryPersonnelValidateAction,
    ITrialGroupLaboratoryPersonnelValidateSuccessAction,
    ITrialGroupLaboratoryPersonnelValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/trialGroupLaboratoryPersonnels";
import { trialGroupLaboratoryPersonnelsApi } from "../services/trialGroupLaboratoryPersonnels";


export const
    getTrialGroupLaboratoryPersonnelsEpic = (action$): Observable<ITrialGroupLaboratoryPersonnelLoadSuccessAction | ITrialGroupLaboratoryPersonnelLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPLABORATORYPERSONNEL_LOAD)
            .mergeMap((_action: ITrialGroupLaboratoryPersonnelsLoadAction) => {
                return trialGroupLaboratoryPersonnelsApi
                    .getTrialGroupLaboratoryPersonnels()
                    .map(response =>
                        LoadSuccess(response.trialGroupLaboratoryPersonnels, undefined, undefined, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialGroupLaboratoryPersonnelByIdEpic = (action$): Observable<ITrialGroupLaboratoryPersonnelLoadSuccessAction | ITrialGroupLaboratoryPersonnelLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPLABORATORYPERSONNEL_LOAD_BY_ID)
            .mergeMap((action: ITrialGroupLaboratoryPersonnelLoadByIdAction) => {
                return trialGroupLaboratoryPersonnelsApi
                    .getTrialGroupLaboratoryPersonnelById(action.id)
                    .map(response =>
                        LoadSuccess(response.trialGroupLaboratoryPersonnel, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialGroupLaboratoryPersonnelByLaboratoryIdEpic = (action$): Observable<ITrialGroupLaboratoryPersonnelLoadSuccessAction | ITrialGroupLaboratoryPersonnelLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPLABORATORYPERSONNEL_LOAD_BY_LABORATORY_ID)
            .mergeMap((action: ITrialGroupLaboratoryPersonnelLoadByLaboratoryIdAction) => {
                return trialGroupLaboratoryPersonnelsApi
                    .getTrialGroupLaboratoryPersonnelByLaboratoryId(action.trialGroupLaboratoryId)
                    .map(response =>
                        LoadSuccess(response.trialGroupLaboratoryPersonnel, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setTrialGroupLaboratoryPersonnelEpic = (action$): Observable<ITrialGroupLaboratoryPersonnelSaveSuccessAction | ITrialGroupLaboratoryPersonnelSaveFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPLABORATORYPERSONNEL_SAVE)
            .mergeMap((action: ITrialGroupLaboratoryPersonnelSaveAction) => {
                return trialGroupLaboratoryPersonnelsApi
                    .setTrialGroupLaboratoryPersonnel(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.trialGroupLaboratoryPersonnel, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createTrialGroupLaboratoryPersonnelEpic = (action$): Observable<ITrialGroupLaboratoryPersonnelCreateSuccessAction | ITrialGroupLaboratoryPersonnelCreateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPLABORATORYPERSONNEL_CREATE)
            .mergeMap((action: ITrialGroupLaboratoryPersonnelCreateAction) => {
                return trialGroupLaboratoryPersonnelsApi
                    .createTrialGroupLaboratoryPersonnel(action.trialGroupLaboratoryId)
                    .map(response =>
                        CreateSuccess(response.trialGroupLaboratoryPersonnel, response.formState, response.formProperties, response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateTrialGroupLaboratoryPersonnelEpic = (action$): Observable<ITrialGroupLaboratoryPersonnelValidateSuccessAction | ITrialGroupLaboratoryPersonnelValidateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPLABORATORYPERSONNEL_VALIDATE)
            .mergeMap((action: ITrialGroupLaboratoryPersonnelValidateAction) => {
                return trialGroupLaboratoryPersonnelsApi
                    .validateTrialGroupLaboratoryPersonnel(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.trialGroupLaboratoryPersonnel, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }